<template>
  <el-row
    class="users"
    v-loading.fullscreen.lock="fullScreenLoading"
  >
    <el-col
      :sm="{span:14, offset: 5}"
      :md="{span:12, offset: 6}"
      :lg="{span:12, offset: 6}"
    >
      <el-header
        height="140px"
        class="app-header pt-50 pb-30"
      >
        <Menu />
        <h3 class="app-header-title mt-0">
          {{ $tc('on-boarding.user', 2) }}
        </h3>
      </el-header>
      <el-main class="organizations-body">
        <el-collapse
          v-model="activeCollapse"
        >
          <el-collapse-item
            class="primary-outline"
            v-for="(user, index) in users"
            :key="index"
          >
            <template slot="title">
              <img
                :src="`https://tippiie-images.s3.eu-central-1.amazonaws.com/public/${user.photoUrl || 'profile.png'}?t=${new Date().getTime()}`"
                :alt="user.name"
                width="40px"
                height="40px"
              >
              <div class="title">
                <p class="organizations-collapse-title">
                  {{ user.name }} {{ user.lastName }}
                </p>
              </div>
            </template>
            <div class="rows-wrapper">
              <div class="row">
                <span class="property">{{ $t('profile.first-name') }}</span>
                <span class="value">{{ user.name }}</span>
              </div>
              <div class="row">
                <span class="property">{{ $t('profile.last-name') }}</span>
                <span class="value">{{ user.lastname }}</span>
              </div>
              <div class="row">
                <span class="property">{{ $t('profile.phone') }}</span>
                <span class="value">{{ user.phoneNumber }}</span>
              </div>
              <div class="row">
                <span class="property">{{ $t('profile.email') }}</span>
                <span class="value">{{ user.email }}</span>
              </div>
              <div class="row">
                <span class="property">{{ $t('organization.title') }}</span>
                <span class="value">{{ user.onboardingOrg }}</span>
              </div>
              <div class="row">
                <span class="property">{{ $t('profile.iban') }}</span>
                <span class="value">{{ user.iban }}</span>
              </div>
            </div>
            <el-row
              type="flex"
              justify="center"
            >
              <el-button
                type="success"
                class="success-button"
                @click="approveUser(user.username)"
              >
                Approve
              </el-button>
            </el-row>
            <el-row>
              <el-col
                :lg="11"
                class="mt-10"
              >
                <router-link
                  :to="{name: 'EditUser', params: { userId: user.username } }"
                  custom
                  v-slot="{ navigate }"
                >
                  <el-button
                    type="primary"
                    class="primary-button"
                    @click="navigate"
                  >
                    {{ $t('form.edit') }}
                  </el-button>
                </router-link>
              </el-col>
              <el-col
                :lg="{span: 11, offset: 2}"
                class="mt-10"
              >
                <el-popconfirm
                  :title="$t('organization.wanna-delete')"
                  icon="el-icon-info"
                  icon-color="red"
                  @confirm="deleteUser(user.username)"
                >
                  <el-button
                    slot="reference"
                    class="primary-outline-button"
                  >
                    {{ $t('menu.delete-user') }}
                  </el-button>
                </el-popconfirm>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
        <el-row
          type="flex"
          justify="center"
        >
          <el-pagination
            background
            layout="prev, next"
            :total="pagination.total"
            :page-size="pagination.limit"
            :current-page.sync="pagination.activePage"
            :hide-on-single-page="true"
            @current-change="changePage"
          />
        </el-row>
      </el-main>
    </el-col>
  </el-row>
</template>

<script>
import Menu from '@/views/Menu/Menu';
import { usersAPI } from '../../shared/services/users.service'

export default {
  name: 'Users',
  components: {
    Menu
  },
  data: function () {
    return {
      isAdmin: false,
      fullScreenLoading: true,
      users: {},
      activeCollapse: [],
      pagination: {
        activePage: this.$route.params.page || 1,
        limit: 10,
        total: 100
      }
    };
  },
  created () {
    this.getUsers();
  },
  methods: {
    getUsers () {
      this.$adminApi.get('/api/v1/onboarding/users', {
        params: {
          limit: this.pagination.limit,
          offset: (this.pagination.activePage - 1) * this.pagination.limit
        }
      }).then((response) => {
        this.users = response.data;
        this.fullScreenLoading = false;
      })
      .catch(() => {
        this.fullScreenLoading = false;
      })
    },
    deleteUser (username = '') {
      this.fullScreenLoading = true;
      this.$adminApi.delete(`/api/v1/onboarding/users/${username}`).then((response) => {
        if (response.data.status === 'Deleted') {
          this.users.splice(this.users.findIndex(item => item.username === username), 1);
        }
        this.fullScreenLoading = false;
      }).catch((error) => {
        this.$message.error(error.message);
      });
    },
    changePage (value) {
      this.fullScreenLoading = true;
      this.users = [];
      let routeParams = {};
      if (value > 1) {
        routeParams = { page: value };
      }
      this.$router.push({ name: 'OnBoardingUsers', params: routeParams });
      this.getUsers();
    },
    async approveUser (username = '') {
      this.fullScreenLoading = true;
      const [ cognitoError ] = await usersAPI.updateCognitoUser([
        {
          attributeName: 'custom:onboarding',
          attributeValue: false,
        }], username)

            if(cognitoError) {
              this.fullScreenLoading = false;
              this.$message.error(this.$t('form.something-wrong'));
              return
            }   

            this.$adminApi.patch(`/api/v1/employees/${username}`).then(() => {
            this.users.splice(this.users.findIndex(item => item.username === username), 1);
            this.$message.success(this.$t('form.item-approved', { item: this.$tc('on-boarding.user', 1) }));
            this.fullScreenLoading = false;
          }).catch((error) => {
            this.$message.error(error.message);
            this.fullScreenLoading = false;
          });
    }
  }
};
</script>

<style scoped lang="scss">
.organizations {
  &-body {
    margin-top: 30px;
    padding: 0 16px;

  }
}
</style>
